module.exports = __webpack_public_path__ + "img/bazi.b82442d5.png";